
import { api } from '@/core/api/'

export default {
  initFilter() {
    return api.get(`api/questionnairesample/initFilters`)
  },
  initFiltersSatisfactionQuestionnaire() {
    return api.get('api/questionnairesample/initfilterssatisfactionquestionnaire')
  },
  initFilterstherapyevaluationquestionaire() {
    return api.get(`api/questionnairesample/initFilterstherapyevaluationquestionaire`)
  }
}